import { Components } from '../../../../component-classes';
import { ActionRuleParams } from '../../types';
import { syncAccessorySkuCount } from '../../helpers';

import type { Island } from '../../../islands/island.class';
import type { Panel } from '../../../panels/panel.class';
import type { PanelItemGroup } from '../../../panel-item-groups/panel-item-group.class';
import type { PanelItem } from '../../../panel-items/panel-item.class';

const SKU = 'CUSTOM_NONCOY_DROPIN';

const isNonCoyoteDropIn = (panelItem: PanelItem): boolean => {
	const { item } = panelItem;
	const { vendor, placement, category } = item;

	// Must be a non-Coyote item (custom appliances have no vendor — treat as non-Coyote)
	if (vendor?.displayValue === 'Coyote') return false;

	// Must be front-and-top placement — front apron cutout + countertop cutout (i.e. Grill)
	if (placement !== Components.PLACEMENT_FRONT_AND_TOP) return false;

	// Exclude cutout category items
	if (category?.key === 'cutout') return false;

	// Exclude stand-alone items (e.g. pizza ovens)
	if (panelItem.isStandAlone) return false;

	return true;
};

export const nonCoyoteDropIn = (params: ActionRuleParams): void => {
	const { refMap } = params;
	const { kitchen } = refMap;
	if (!kitchen) return;

	const islands = refMap.islands ?? kitchen.design?.islands ?? null;
	if (!islands) return;

	let qualifyingCount = 0;

	for (const child of islands.children) {
		const island = child as Island;

		for (const panel of island.panels.children) {
			const typedPanel = panel as Panel;

			for (const group of typedPanel.panelItemGroups.children) {
				const typedGroup = group as PanelItemGroup;

				for (const panelItem of typedGroup.items.children) {
					if (isNonCoyoteDropIn(panelItem as PanelItem)) {
						qualifyingCount++;
					}
				}
			}
		}
	}

	syncAccessorySkuCount({ kitchen, sku: SKU, qualifyingCount });
};
